import React from 'react';
import { observer } from 'mobx-react-lite';
import type { ImageElement } from '@/types';
import { ConnectionPoints } from './ConnectionPoints';

interface ImageElementProps {
  element: ImageElement;
  isSelected: boolean;
}

export const ImageElementComponent: React.FC<ImageElementProps> = observer(({ element, isSelected }) => {
  const { id, x, y, width, height, imageData, style } = element;

  return (
    <g>
      {/* Image content container */}
      <g clipPath={`url(#image-clip-${id})`}>
        <defs>
          <clipPath id={`image-clip-${id}`}>
            <rect x={x} y={y} width={width} height={height} />
          </clipPath>
        </defs>
        
        {/* Render the image */}
        <foreignObject
          x={x}
          y={y}
          width={width}
          height={height}
          opacity={style.opacity}
        >
          <div
            style={{
              width: '100%',
              height: '100%',
              overflow: 'hidden',
              pointerEvents: 'none',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <img
              src={imageData}
              alt="Pasted image"
              style={{
                maxWidth: '100%',
                maxHeight: '100%',
                objectFit: 'contain',
              }}
            />
          </div>
        </foreignObject>
        
        {/* Invisible clickable area */}
        <rect
          x={x}
          y={y}
          width={width}
          height={height}
          fill="transparent"
          style={{ cursor: 'move' }}
        />
      </g>

      {/* Connection points */}
      <ConnectionPoints
        element={element}
        zoom={1}
        isHovered={isSelected}
      />

      {/* Selection indicators */}
      {isSelected && (
        <g>
          {/* Selection border */}
          <rect
            x={x - 2}
            y={y - 2}
            width={width + 4}
            height={height + 4}
            fill="none"
            stroke="#007acc"
            strokeWidth={2}
            strokeDasharray="5,5"
            rx={4}
          />
          {/* Resize handles */}
          <rect x={x - 6} y={y - 6} width={8} height={8} fill="#007acc" stroke="#ffffff" strokeWidth={1} />
          <rect x={x + width - 2} y={y - 6} width={8} height={8} fill="#007acc" stroke="#ffffff" strokeWidth={1} />
          <rect x={x - 6} y={y + height - 2} width={8} height={8} fill="#007acc" stroke="#ffffff" strokeWidth={1} />
          <rect x={x + width - 2} y={y + height - 2} width={8} height={8} fill="#007acc" stroke="#ffffff" strokeWidth={1} />
          <rect x={x + width/2 - 4} y={y - 6} width={8} height={8} fill="#007acc" stroke="#ffffff" strokeWidth={1} />
          <rect x={x + width/2 - 4} y={y + height - 2} width={8} height={8} fill="#007acc" stroke="#ffffff" strokeWidth={1} />
          <rect x={x - 6} y={y + height/2 - 4} width={8} height={8} fill="#007acc" stroke="#ffffff" strokeWidth={1} />
          <rect x={x + width - 2} y={y + height/2 - 4} width={8} height={8} fill="#007acc" stroke="#ffffff" strokeWidth={1} />
        </g>
      )}
    </g>
  );
}); 